module.exports = "/images/side-my-account.svg?a57a837f9047681d8f5c782f76ae9f15";